// academic_projects_list: ["论文", "比赛", "课程"],
export function academic_projects_placeholder(type) {
    if (type == '论文') {
        return {
            "desc":"1.简短的描述，论文研究的方向，研究的价值，研究的产出;\n2.负责哪些内容;\n3.所用的方法，例如用了什么软件，什么实验设施，什么数据架构模型或者什么理论知识，分析了什么数据，构建了什么模型等",
            // "introduction":"简短的描述，论文研究的方向，研究的价值，研究的产出",
            // "responsibility":'负责哪些内容',
            // "methodology":"所用的方法，例如用了什么软件，什么实验设施，什么数据架构模型或者什么理论知识，分析了什么数据，构建了什么模型等",
            "outcome":"发表的期刊"
        }
    } else if (type == '比赛') {
        return {
            "desc":"1.简短的描述比赛内容;\n2.负责哪些内容;\n3.所用的方法，例如用了什么软件，什么实验设施，什么数据架构模型或者什么理论知识，分析了什么数据，构建了什么模型等。",
            // "introduction":"简短的描述比赛内容",
            // "responsibility":'负责哪些内容',
            // "methodology":"所用的方法，例如用了什么软件，什么实验设施，什么数据架构模型或者什么理论知识，分析了什么数据，构建了什么模型等。",
            "outcome":"得奖情况"
        }
    } else if (type == "课程") {
        return {
            "desc":"1.简短的描述，论文研究的方向，研究的价值，研究的产出;\n2.所用的方法，例如用了什么软件，什么实验设施，什么数据架构模型或者什么理论知识，分析了什么数据，构建了什么模型等",
            // "introduction":"简短的描述，论文研究的方向，研究的价值，研究的产出",
            // "responsibility":'',
            // "methodology":"所用的方法，例如用了什么软件，什么实验设施，什么数据架构模型或者什么理论知识，分析了什么数据，构建了什么模型等",
            "outcome":"最终期末考试的得分"
        }
    } else {
        return {
            "desc":"请先选择类型",
            "outcome":""
        }
    }
}
export function academic_projects_placeholder_type(type) {
  if (type == '论文') {
    return {
      "outcome":"期刊号"
    }
  } else {
    return {
      "outcome":"最终结果"
    }
  }
}
export function academic_projects_placeholder_type_name(type) {
  if (type == '比赛') {
    return {
      "outcome":"比赛项目名称"
    }
  } else {
    return {
      "outcome":"名称"
    }
  }
}

export function work_experience_placeholder() {
    return {
        "responsibility":"负责工作的内容（详细写出，做了什么，怎么做，最后的结果，从公司的利润，数据的体现这两个角度进行描述）"
    }
}

export function ps_baseinfo_write_requirment(key) {
  const result = {
    "职业规划":'1.进入XXX公司/机构，担任XXX岗位，实现XXX目标；\n2.建议思考方向为你愿意终生付出时间的职业，切记写很大很空的职业规划，可以关心民生问题（前提是跟你本身的动机和学术追求逻辑相关）\n\n\n备注：如果希望申读PHD或继续在科研（教研）领域探索，则务必说明自己希望从事研究的领域是什么，可能需要具备的科学研究技能，该科研项目未来的应用趋势。（需要给出具体的研究兴趣方向）',
    "选校/项目原因":"选2门你最喜欢的课程，说明该课程能为你带来的实际帮助",
    "学术竞争力":"选1-2个（不要超过3个）你最骄傲的，你觉得只有你可以完成的学术成就，可以是出版物，研究，课程项目，小组作业，比赛等等。一个项目不要超过200字。\n用最简洁的语言说清楚这个项目到底为什么让你最骄傲？最好给出具体的，可以看得到的成果，比如：收录于XXX杂志。不要写感想性质的，没有用（比如这个项目让我非常感动我们小组的队友情）",
    "实践竞争力":"选1-2个（不要超过3个）你最骄傲的实习，一个项目不要超过200字。\n业内big name的公司，有实际产出的优先。\n最好给出具体的，可以看得到的成果，比如：运营的账号实现了10%的转化率。\n同样地，切记不要写感想性质的，没有用（比如这个项目让我非常感动我们小组的队友情）",
    "其他补充":"这里可以备注你不确定是否要写进PS里面，但是又觉得对你很重要的信息。\n比如：我大二的时候，考XXX的前一天晚上得知了一个XXX的不幸消息，对我的身心造成了巨大的创伤，应激反应之下我一夜没睡，也忘记了我可以尝试找老师沟通不考试直接参加补考，迷迷糊糊就走去考试了，考场上也不知道自己在干什么，最后分数不理想。等我后面去看心理医生，逐渐恢复，反应过来的时候分数已经出了，我尝试跟老师沟通重考或者重修，都被老师以学校规定无这一项为由拒绝。因为这门课的影响，我GPA低于XXX，但我认为这不能反应我真实的学术能力。",
    "本专业申请":'直接告知学校自己的诉求和未来规划。什么原因导致你必须要在研究生的级别学习这个专业？（一个就够了）\n比如：目前能力欠缺-影响升职加薪；想深入学习专业知识-读博/做研究；之前的本科课程少了XXX，以后想干XXX，以本科生就业不够，所以想要在研究生阶段补足。\n备注：全职工作3年以上，申请专业和工作领域相关属于此情况。毕业后直接转专业不适合。参考：我本科专业是市场营销，课程设置比较宽泛，学习到了很多市场营销的理论知识。在电子营销课程中，我通过完成XXXX项目，发现自己最感兴趣的是电子营销，以后也想在这一行业工作，所以想要申请电子营销硕士课程。\n\n\n备注：除非你的父母真的在这个领域很牛，有可以量化拿出来讲的实际成就（潜台词是招了你=你父母的资源可以共享给学校），动机部分不建议写父母影响。朋友和亲戚同理。你的父母亲戚朋友跟你的学术能力没有任何关系，他们是他们，你是你。除非你个人而言真的是实在没有任何东西可以讲了，再去说你身边的人。另外，不是在你申请的领域非常出色，或者世界范围内非常有名的人，在PS里面提到对你的申请没有任何帮助。',
    '有相关背景的转专业申请':'为什么非得转这个专业？本科专业和申请专业的交叉是什么？为什么不申请原来的专业？为什么非得是你想申请的这个专业？\n一定要突出你必须转专业对你未来的帮助（请代入“我不得不转专业，不转不行”来思考这一问题的答案）。\n参考：因为我非常关心环境保护，本科学了环境工程，但是在实习过程中发现，国内大环境对于环境工程发展不利，想要真正实现我的理想，需要走到管理岗。有环境工程方面的专业工科知识和管理方面的技能，才能制定监督管控好环保政策。我已经具备了专业工科知识，却没有形成系统的管理思路，所以我想申请工程管理专业。\n\n\n备注：除非你的父母真的在这个领域很牛，有可以量化拿出来讲的实际成就（潜台词是招了你=你父母的资源可以共享给学校），动机部分不建议写父母影响。朋友和亲戚同理。你的父母亲戚朋友跟你的学术能力没有任何关系，他们是他们，你是你。除非你个人而言真的是实在没有任何东西可以讲了，再去说你身边的人。另外，不是在你申请的领域非常出色，或者世界范围内非常有名的人，在PS里面提到对你的申请没有任何帮助。',
    "无相关背景的转专业申请":"1.为什么非得转这个专业？\n2.为之付出了什么努力（通过具体事情，比如选修了相关课程、听了网课、找了相关实习或工作）？\n3.为什么现在需要这个研究生的课程（比如自学不成体系、缺少特点专业知识）？\n备注：全职工作3年以上，申请专业和工作领域无关属于此情况。毕业后直接转专业适合。参考：我在XXX实习中发现，我真正感兴趣的是XXX行业。以后的职业规划是XXX，缺少XXX，所以想申请XXX专业。（一般我们不用特别在PS里面提及“我转专业”，老师看你其他材料一看就知道了。转专业的文书重点是去写你原本做的事情，跟这个项目的相关性）\n\n\n备注：除非你的父母真的在这个领域很牛，有可以量化拿出来讲的实际成就（潜台词是招了你=你父母的资源可以共享给学校），动机部分不建议写父母影响。朋友和亲戚同理。你的父母亲戚朋友跟你的学术能力没有任何关系，他们是他们，你是你。除非你个人而言真的是实在没有任何东西可以讲了，再去说你身边的人。另外，不是在你申请的领域非常出色，或者世界范围内非常有名的人，在PS里面提到对你的申请没有任何帮助。"

  }
  return result[key] || ''
}



// WEBPACK FOOTER //
// ./src/components/mycenter_studyabroad/HBCommon/placeholder.js